import styled, { css } from "styled-components";
import { COLORS } from "../../../../styles/constants.style";
import { SUMMARY_CARD_TYPE } from "./SummaryCard";

type SummaryCardType = keyof typeof SUMMARY_CARD_TYPE;

const getCardStyles = (type: SummaryCardType) => {
  switch (type) {
    case SUMMARY_CARD_TYPE.processed:
      return css`
        background-color: ${COLORS.cirrus_green1};
        color: ${COLORS.cirrus_white};
      `;
    case SUMMARY_CARD_TYPE.unprocessed:
      return css`
        background-color: ${COLORS.cirrus_red};
        color: ${COLORS.cirrus_white};
      `;
    case SUMMARY_CARD_TYPE.activities:
      return css`
        background-color: ${COLORS.cirrus_black8};
        color: ${COLORS.cirrus_white};
      `;
    default:
      return css`
        background-color: ${COLORS.cirrus_black8};
        color: ${COLORS.cirrus_white};
      `;
  }
};

const getIconStyles = (type: SummaryCardType) => {
  switch (type) {
    case SUMMARY_CARD_TYPE.processed:
      return css`
        background-color: ${COLORS.cirrus_green2};
        color: ${COLORS.cirrus_white};
        border: 2px solid ${COLORS.cirrus_green2};
      `;
    case SUMMARY_CARD_TYPE.unprocessed:
      return css`
        color: ${COLORS.cirrus_white};
        background-color: ${COLORS.cirrus_dark_red};
        border: 2px solid ${COLORS.cirrus_dark_red};
      `;
    case SUMMARY_CARD_TYPE.activities:
      return css`
        color: ${COLORS.cirrus_white};
        background-color: ${COLORS.cirrus_black10};
        border: 2px solid ${COLORS.cirrus_black10};
      `;
    default:
      return css`
        background-color: ${COLORS.cirrus_black10};
        color: ${COLORS.cirrus_white};
        border: 2px solid ${COLORS.cirrus_black10};
      `;
  }
};

export const SummaryCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;
export const IconCircle = styled.div<{ type: SummaryCardType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  ${({ type }) => getIconStyles(type)};
  svg {
    font-size: 18px;
  }
`;

export const IconBox = styled.div<{ type: SummaryCardType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 700;
  ${({ type }) => getCardStyles(type)}
  svg {
    font-size: 22px;
  }
`;

export const CountText = styled.span<{ type: SummaryCardType }>`
  font-size: 18px;
  font-weight: 700;
  ${({ type }) => getCardStyles(type)};
`;

export const LabelText = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
